import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import DropDown from '../../../../../../../../../../components/DropDown/DropDown'
// import Exlmation from '../../../../../../../../assets/images/icons/exlmation.svg'
import Exlmation from '../../../../../../../../../../assets/images/icons/exlmation.svg'
import { Col, Row } from 'react-bootstrap'
import AddColorModel from '../../../../../../../../../../components/AllModelForm/AddColorModel/AddColorModel'
import { getColorId } from '../../../../../../../../../../Redux-Toolkit/Slices/catalogSlice'
import { useDispatch } from 'react-redux'

const AddColor = ({
    addvariantLength,
    kkk,
    miliChoice,
    name,
    control,
    errors,
    index,
    onChange
}) => {
    const { colorData, allColorId } = useSelector(
        (action) => action.catalogSlice
    )
    console.log(allColorId, 'allColorId')
    const dispatch = useDispatch()
    const [first, setfirst] = useState([])
    const [colorModalShow, setColorModalShow] = useState(false)

    // useEffect(() => {
    //     const abc = addVariantDataList.map((res) => {
    //         return res?.color?._id
    //     })
    //     console.log(abc,"ABCCCCCCCCCCC")
    //     dispatch(getColorId({id:abc}))

    //     // setChoco(abc)
    // }, [])

    const addColor = () => {
        const finalData = colorData?.filter(
            (e) => !allColorId?.includes(e?._id)
        )
        console.log(finalData, 'finalData', colorData)
        return [...finalData, { name: 'Add Color' }]
    }
    ///// end color drop down  //////

    // Listen for changes in selectedColorData and update the color field value
    // useEffect(() => {
    //     if (selectedColorData) {
    //         // fields.forEach((field, index) => {
    //         //     setValue(`addVariant.${index}.color`, selectedColorData)
    //         // })
    //         setValue(name,value)
    //     }
    // }, [selectedColorData])

    return (
        <>
            <Col xl="3" lg="6" md="6">
                <div className="form-group">
                    <label>
                        Color
                        <span className="error">*</span>
                        <img
                            src={Exlmation}
                            className="error-icon"
                            alt="not found"
                        />
                    </label>
                    {console.log(
                        miliChoice,
                        'FIhhhhhhRST',
                        index,
                        addvariantLength,
                        miliChoice + index
                    )}
                    <DropDown
                        DropDownCategory={addColor(index)}
                        control={control}
                        setfirst={(ert) => {
                            dispatch(
                                getColorId({
                                    id: kkk ? ert?._id : ert?._id,
                                    index: miliChoice
                                        ? miliChoice + index
                                        : addvariantLength
                                        ? addvariantLength + index
                                        : index
                                })
                            )
                        }}
                        ddname="name"
                        name={name}
                        setColorModalShow={setColorModalShow}
                    />
                    {errors && (
                        <span
                            className="invalid"
                            style={{
                                color: 'red'
                            }}
                        >
                            {errors?.addVariant?.[index]?.color?.message}
                        </span>
                    )}
                </div>
            </Col>

            {colorModalShow && (
                <AddColorModel
                    colorModalShow={colorModalShow}
                    setColorModalShow={setColorModalShow}
                    onChange={onChange}
                />
            )}
        </>
    )
}

export default AddColor
